import React from "react";
import {Icon, Text, Flex} from "@chakra-ui/react";
import {MdCancel, MdCheckCircle, MdOutlineError} from "react-icons/md";
import {RENTAL_STATUS} from "../../variables/rentalStatus";
import {USER_STATUS} from "../../variables/userStatus";

export default function UserStatus(props) {

    const {status} = props;

    return (
        <Flex alignItems={"center"}>
            <Icon
                w='24px'
                h='24px'
                me='5px'
                color={
                    status === USER_STATUS.HASRENTALS
                        ? "green.500"
                        : status === USER_STATUS.NORENTALS
                            ? "orange.500"
                            : status === USER_STATUS.UNCONFIRMED
                                ? "red.500"
                                : null
                }
                as={
                    status === USER_STATUS.HASRENTALS
                        ? MdCheckCircle
                        : status === USER_STATUS.NORENTALS
                            ? MdCancel
                            : status === USER_STATUS.UNCONFIRMED
                                ? MdOutlineError
                                : null
                }
            />
            <Text>
                {status === USER_STATUS.HASRENTALS
                    ? "hat Inserate"
                    : status === USER_STATUS.NORENTALS
                        ? "keine Inserate"
                        : status === USER_STATUS.UNCONFIRMED
                            ? "nicht bestätigt"
                            : null}
            </Text>
        </Flex>
    );
}
